import { Modal } from "antd";
import dangerWarning from "../../asset/DangerWarning.png";
import TriagleWarning from "../../asset/triagleWarning.svg";
import "./style.css";

import { Button } from "antd";

const RemoveDraftSheetModal = (props) => {
  return (
    <Modal
      width={600}
      open={props.open}
      onOk={props.onOk}
      onCancel={props.onCancel}
      wrapClassName={"termAndConditionSellerModal"}
      footer={null}
    >
      <img
        src={TriagleWarning}
        alt="triagleWarning"
        className="triagleWarning"
      />
      <div className="termAndConditionSellerBody">
        <img src={dangerWarning} alt="dangerWarningIcon" />

        <h1>ลบชีทสรุปที่ยังไม่เผยแพร่</h1>
        <div className="penelty">
          <p className="">
            เมื่อยืนยันการลบแล้วจะไม่สามารถกู้รายการกลับมาได้ <br />
            คุณยืนยันที่จะลบชีทสรุปที่ยังไม่เผยแพร่ใช่หรือไม่
          </p>
        </div>

        <div className="btn-group">
          <Button
            type="text"
            shape="round"
            className={"cancelBtn"}
            size="large"
            onClick={props.onCancel}
          >
            ยกเลิก
          </Button>
          <Button
            shape="round"
            className={"acceptBtn"}
            size="large"
            onClick={props.onOk}
          >
            ยืนยัน
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveDraftSheetModal;
